import { selector } from "recoil";
import { remoteDatePromise } from '../utils/RemoteDateGenerator';

export const remoteDateState = selector({
	key: 'remoteDateState',
	get: async() => {
    try {
      const remoteDate = await remoteDatePromise;
      // eslint-disable-next-line
      Date = remoteDate;
      return remoteDate;
    } catch(error) {
      throw new Error(error);
    };
  }
});
